import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PartModel} from './partModel';
import { PartModelService } from './partModel.service';
import { NotificationService} from 'app/shared/notification/notification.service';
import { MatTableDataSource, PageEvent } from '@angular/material';
import { TableService } from 'app/core/models/pager';
import { PartModelFilter } from './partModel.filter';
import { HttpParams } from '@angular/common/http';

@Component({
	template: `
		<h3 class="title" i18n="@@partModels">Part Models</h3>

		<mat-accordion>
			<mat-expansion-panel [expanded]="isOpenSearchPanel" (opened)="openSearchPanel(true)" [hideToggle]="true">
				<mat-expansion-panel-header>
					<div *ngIf="tableService.filter" class="filter-panel-header fieldset-wrap">
						<div class="field-row">
							<div class="field-row-item" *ngIf="tableService.filter.code">
								<span class="label" i18n="@@code">Code</span>
								<span>{{tableService.filter.code}}</span>
							</div>
							<div class="field-row-item" *ngIf="tableService.filter.name">
								<span class="label" i18n="@@name">Name</span>
								<span>{{tableService.filter.name}}</span>
							</div>
						</div>
					</div>
					<button class="btn-icon" i18n-title="@@option-search" title="Search" type="button">
						<i class="material-icons">search</i>
					</button>
				</mat-expansion-panel-header>

				<form>
					<fieldset class="fieldset">
						<div class="field-row">
							<div class="field-row-item">
								<label class="label" for="code" i18n="@@code">Code</label>
								<input type="text" name="code" placeholder="None" i18n-placeholder="None" [(ngModel)]="filter.code">
							</div>
						</div>
						<div class="field-row">
							<div class="field-row-item">
								<label class="label" for="name" i18n="@@name">Name</label>
								<input type="text" name="name" placeholder="None" i18n-placeholder="None" [(ngModel)]="filter.name">
							</div>
						</div>
					</fieldset>
					<div class="options">
						<button class="btn-text gray" type="button" (click)="reset()">
							<span i18n="@@option-reset">Reset</span>
						</button>
						<button class="btn-text blue" type="button" (click)="search()">
							<span i18n="@@option-search">Search</span>
						</button>
					</div>
				</form>
			</mat-expansion-panel>
		</mat-accordion>

		<div class="tool-bar-wrap both-side">
			<div class="right row">
				<button class="btn-icon" i18n-title="@@option-create" type="button" (click)="create()" *hasPermission="['PartModels.create']">
					<i class="material-icons">add</i>
				</button>
				<ng-template [hasPermission]="['PartModels.delete']">
					<button class="btn-icon" i18n-title="@@option-delete" title="Delete" type="button" (click)="confirmDelete = false" *ngIf="tableService.selection.hasValue()">
						<i class="material-icons">delete</i>
					</button>
				</ng-template>
			</div>
		</div>

		<div class="mat-elevation-z8e" *ngIf="dataSource">
			<table mat-table [dataSource]="dataSource" matSort (matSortChange)="tableService.sortData($event); list();">
				<ng-container matColumnDef="select">
					<th mat-header-cell *matHeaderCellDef>
						<mat-checkbox (change)="tableService.masterToggle(dataSource.data)"
							[checked]="tableService.selection.hasValue() && tableService.isAllSelected(dataSource.data.length)"
							[indeterminate]="tableService.selection.hasValue() && !tableService.isAllSelected(dataSource.data.length)"
							*hasPermission="['PartModels.delete']">
						</mat-checkbox>
					</th>
					<td mat-cell *matCellDef="let row">
						<mat-checkbox (click)="$event.stopPropagation()"
							(change)="tableService.selection.toggle(row)"
							[checked]="tableService.selection.isSelected(row)"
							*hasPermission="['PartModels.delete']">
						</mat-checkbox>
					</td>
				</ng-container>

				<ng-container matColumnDef="code">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@code">Code</th>
					<td mat-cell *matCellDef="let element">{{element.code}}</td>
				</ng-container>

				<ng-container matColumnDef="name">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@name">Name</th>
					<td mat-cell *matCellDef="let element">{{element.name}}</td>
				</ng-container>

				<ng-container matColumnDef="stock">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@stock">Stock</th>
					<td mat-cell *matCellDef="let element">{{element.stock}}</td>
				</ng-container>

				<ng-container matColumnDef="price">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@price">Price</th>
					<td mat-cell *matCellDef="let element">{{element.price}}</td>
				</ng-container>

				<ng-container matColumnDef="price2">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@price2">Second price</th>
					<td mat-cell *matCellDef="let element">{{element.price2}}</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns;"
					(contextmenu)="tableService.selection.clear(); tableService.selection.select(row)" [contextMenu]="basicMenu" [contextMenuSubject]="row"
					(click)="read(row)">
				</tr>
			</table> 

			<mat-paginator showFirstLastButtons
				[length]="tableService.pager.totalEntities"
				[pageIndex]="tableService.pager.pageIndex"
                [pageSize]="tableService.pager.pageSize"
				[pageSizeOptions]="[20, 50, 100]"
				(page)="list($event)">
			</mat-paginator>
		</div>

		<context-menu #basicMenu>
			<ng-template [hasPermission]="['PartModels.update']">
				<ng-template contextMenuItem (execute)="update($event.item)">
					<div class="item">
						<i class="material-icons">edit</i>
						<span i18n="@@option-update">Update</span>
					</div>
				</ng-template>
			</ng-template>
			<ng-template [hasPermission]="['MediaController.createPartModels']">
				<ng-template contextMenuItem (execute)="updateImages($event.item)">
					<div class="item">
						<i class="material-icons">collections</i>
						<span i18n="@@option-update-images">Update images</span>
					</div>
				</ng-template>
				<ng-template contextMenuItem (execute)="updatePdfs($event.item)">
					<div class="item">
						<i class="material-icons">picture_as_pdf</i>
						<span i18n="@@option-update-pdfs">Update PDF files</span>
					</div>
				</ng-template>
			</ng-template>

			<ng-template [hasPermission]="['PartModels.delete']">
				<ng-template contextMenuItem divider="true"></ng-template>
				<ng-template contextMenuItem (execute)="confirmDelete = false">
					<div class="item">
						<i class="material-icons">delete</i>
						<span i18n="@@option-delete">Delete</span>
					</div>
				</ng-template>
			</ng-template>
		</context-menu>

		<modal-ns [(closed)]="confirmDelete">
			<ng-template modalContentDirective>
				<div class="dialog-content">
					<div class="dialog-title" i18n="@@confirm">Confirmation</div>
					<div class="dialog-message" i18n="@@confirm-deletes">Are you sure you want to delete the selected items?</div>
					<div class="options">
						<button class="btn-text red" type="button" (click)="confirmDelete = true">
							<span i18n="@@option-no">No</span>
						</button>
						<button class="btn-text green" type="button" (click)="deletes(); confirmDelete = true">
							<span i18n="@@option-yes">Yes</span>
						</button>
					</div>
				</div>
			</ng-template>
		</modal-ns>
	`
})
export class PartModelListComponent implements OnInit {
	dataSource: MatTableDataSource<PartModel>;
	displayedColumns: string[] = ['select', 'code', 'name', 'stock', 'price', 'price2'];
	confirmDelete = true;
	isOpenSearchPanel = false;
	filter = new PartModelFilter(this.tableService.filter);

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private partModelService: PartModelService,
		public tableService: TableService<PartModel>,
		private notificationService: NotificationService
	) {}

	ngOnInit() {
		this.list();
	}

	list(event?: PageEvent) {
		let httpParams = new HttpParams()
			.set('collection', 'id, name, code, stock, price, price2')
			.set('pager.index', event ? event.pageIndex.toString() : this.tableService.pager.pageIndex.toString())
			.set('pager.size', event ? event.pageSize.toString() : this.tableService.pager.pageSize.toString());

		if (this.tableService.sort) { httpParams = httpParams.set('sort', this.tableService.sort) }

		httpParams = this.filter.getHttpParams(httpParams);

		this.partModelService.getAll(httpParams).subscribe(data => {
			this.dataSource = new MatTableDataSource<PartModel>(data['result']);
			this.tableService.pager = data['pager'];
			this.tableService.selection.clear();
		});
	}

	manageMedia(item: PartModel) {
		this.router.navigate(['./' + item.id + '/media'], {relativeTo: this.activatedRoute});
	}

	create() {
		this.router.navigate(['./create'], {relativeTo: this.activatedRoute});
	}

	update(item: PartModel) {
		this.router.navigate(['./' + item.id + '/update'], {relativeTo: this.activatedRoute});
	}

	updateImages(item: PartModel) {
		this.router.navigate(['./' + item.id + '/image/update'], {relativeTo: this.activatedRoute});
	}

	updatePdfs(item: PartModel) {
		this.router.navigate(['./' + item.id + '/pdf/update'], {relativeTo: this.activatedRoute});
	}

	read(item: PartModel) {
		this.router.navigate(['./' + item.id], {relativeTo: this.activatedRoute});
	}

	deletes() {
		const length = this.tableService.selection.selected.length;
		this.tableService.pager.pageIndex = (this.tableService.pager.pageIndex > 0 && this.tableService.pager.totalEntitiesPerPage === length) ?
			--this.tableService.pager.pageIndex : this.tableService.pager.pageIndex;

		if (length === 1) {
			this.partModelService.delete(this.tableService.selection.selected[0].id).subscribe(() => {
				this.notificationService.sucessDelete();
				this.list();
			}, err => this.notificationService.error(err));
		} else if (length > 1) {
			this.partModelService.deletes(this.tableService.selection.selected).subscribe(() => {
				this.notificationService.sucessDelete();
				this.list();
			}, err => this.notificationService.error(err));
		}
	}

	reset() {
		this.filter = new PartModelFilter();
	}

	search() {
		this.isOpenSearchPanel = false;
		this.tableService.pager.pageIndex = 0;
		this.tableService.filter = new PartModelFilter(this.filter);
		this.list();
	}

	openSearchPanel(value: boolean) {
		this.isOpenSearchPanel = value;
		this.filter = new PartModelFilter(this.tableService.filter);
	}

	compareFn(c1: any, c2: any): boolean {
		return c1 && c2 ? c1.id === c2.id : c1 === c2;
	}
}
